import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { FormValidatorService } from '../../../../shared/services/form-validator.service';
import { ForgotPasswordService } from '../../services/forgot-password.service';
import { Validators } from '../../../../shared/validators';
import { environment } from '../../../../../environments/environment';
import { LanguageService } from '../../../../shared/services/language.service';
import { ReCaptchaService } from 'angular-recaptcha3';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  forgotForm: FormGroup;
  formValidator: FormValidatorService = new FormValidatorService();
  defaultEmail = '';
  submitted = false;

  constructor(
    private route: ActivatedRoute,
    private forgotPasswordService: ForgotPasswordService,
    private location: Location,
    private translate: TranslateService,
    private languageService: LanguageService,
    private recaptchaService: ReCaptchaService,
  ) { }

  ngOnInit() {
    this.translate.use(localStorage.getItem('language'));
    this.languageService.languageUpdated.subscribe((lang) => {
      this.translate.use(lang);
    })
    if (this.route.data && this.route.snapshot.data.email) {
      this.defaultEmail = this.route.snapshot.data.email;
    }
    this.forgotForm = this.formValidator.createForm([
      {
        fieldName: 'email',
        defaultValue: this.defaultEmail,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
          {
            validatorFn: Validators.email,
            message: '',
          }
        ]
      }
    ]);
  }

  ngAfterViewInit() {
    this.translateValidationMessages();
    this.translate.onLangChange.subscribe(() => {
      this.translateValidationMessages();
    })
  }

  translateValidationMessages() {
    this.translate.get('FormValidation').subscribe(() => {
      this.formValidator.validationMessages = {
        "email": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Email',
            fieldAr: 'البريد الإلكتروني'
          }),
          email: this.translate.instant('FormValidation.ValidEmail'),
        },
      }
    });
  }

  async onSubmit() {
    const recaptchaToken = await this.recaptchaService.execute({
      action: 'sendRestMail',
    });
    const toService = {
      mail: this.forgotForm.value.email,
      redLink: `${environment.BASE_URL}password/reset`,
      recaptchaToken,
    };
    this.forgotPasswordService.setParams(toService);
    let res =await this.forgotPasswordService.make();
    Swal.fire({
      title: "Sent done!",
      text: res.message,
      icon: "success"
    });
    this.submitted = true;
  }

  async onCancel() {
    this.location.back();
  }
}
